// sdal-project-frontend/src/services/api.js

import axios from 'axios';
// Not: Django sunucunuzun portu 8000
const API_URL = 'https://sdal-project-backend.onrender.com/api';

const api = axios.create({
    baseURL: API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Axios Request Interceptor (İstek Kesicisi)
// Her API isteği gönderilmeden önce bu fonksiyon çalışır ve Token ekler.
api.interceptors.request.use(
    (config) => {
        // MembershipPage.tsx içinde 'access' olarak kaydedildiği için burayı da 'access' yaptık
        const token = localStorage.getItem('access');
        if (token) {
            // Authorization: Bearer <token> formatında token'ı ekle
            config.headers.Authorization = `Bearer ${token}`; 
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default api;